const checkStickyVisibility = () => {
  const stickyBar = document.querySelector('[data-sticky-add-to-cart]');
  if (!stickyBar) return;

  const mainBtn = document.querySelector('.wm-builder-add');

  let isBtnOutOfScreen = false;
  if (mainBtn) {
    // Only show sticky ATC if user scrolled PAST the main button (it went above the viewport)
    const rect = mainBtn.getBoundingClientRect();

      isBtnOutOfScreen = rect.bottom < 0;
  }

  if (isBtnOutOfScreen) {
    stickyBar.classList.add('is-visible');
  } else {
    stickyBar.classList.remove('is-visible');
  }
};

let ticking = false;
document.addEventListener('scroll', () => {
  if (!ticking) {
    window.requestAnimationFrame(() => {
      checkStickyVisibility();
      ticking = false;
    });
    ticking = true;
  }
}, { passive: true });

const initStickyObserver = () => {
  const mainBtn = document.querySelector('[data-wm-builder-add]');
  const stickyBtn = document.querySelector('.product-form__submit-sticky');
  const builder = document.querySelector('.wm-builder');
  
  if (mainBtn && stickyBtn && builder) {
    const observer = new MutationObserver(() => {
      const isL = builder.classList.contains('is-loading');
      stickyBtn.classList.toggle('is-loading', isL);
    });
    observer.observe(builder, { attributes: true, attributeFilter: ['class'] });
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initStickyObserver);
} else {
  initStickyObserver();
}

window.handleStickyAddToCart = function(stickyBtn) {
  const mainBtn = document.querySelector('[data-wm-builder-add]');
  if (mainBtn) {
    mainBtn.click();
  } else if (window.openBuilder) {
    window.openBuilder();
  }
};

window.addEventListener('pageshow', () => {
  const stickyBtn = document.querySelector('.product-form__submit-sticky');
  const builder = document.querySelector('.wm-builder');
  if (stickyBtn && (!builder || !builder.classList.contains('is-loading'))) {
    stickyBtn.classList.remove('is-loading');
  }
});
